import BaseService from '../baseServices';
import REST from '../../configs/rest';

function putWorkOrderDetail({ body, id }) {
  return BaseService.put(REST.WORK_ORDER_DETAIL(id), body);
}

function postWorkOrderDetail({ body, id }) {
  return BaseService.post(REST.WORK_ORDER_DETAIL(id), body);
}

export default {
  putWorkOrderDetail,
  postWorkOrderDetail,
};
